function initPimpSeedsCompactAbos() {
  document.querySelectorAll('[data-ps-abo-compact]').forEach(root => {
    if (root.dataset.compactInitialized) return;
    root.dataset.compactInitialized = 'true';
    const config = JSON.parse(root.querySelector('[data-ps-config]').textContent);
    const form = root.querySelector('form');
    const submit = root.querySelector('[data-ps-submit]');
    const planInput = root.querySelector('[data-ps-plan]');
    const consent = root.querySelector('[data-ps-consent]');
    const acceptedTerms = root.querySelector('[data-ps-accepted-terms]');
    const journey = root.querySelector('[data-ps-journey]');
    const motion = root.querySelector('[data-ps-motion]');
    const money = cents => 'CHF ' + (cents / 100).toFixed(2);
    const render = (template, values) => template.replace(/\{(\w+)\}/g, (match, key) => values[key] ?? match);
    const setText = (selector, value) => { root.querySelector(selector).textContent = value; };
    const update = () => {
      const data = new FormData(form);
      const quantity = Number(data.get('quantity'));
      const cycle = data.get('properties[_Rhythmus]');
      const term = data.get('properties[_Abo]');
      const prepaid = term === 'prepaid';
      const monthly = cycle === 'month';
      const deliveries = monthly ? 3 : 6;
      const unit = prepaid ? 531 : 590;
      const perDelivery = quantity * unit;
      const charge = perDelivery * (prepaid ? deliveries : 1);
      const normal = quantity * 590 * deliveries;
      const discounted = quantity * 531 * deliveries;
      const savings = normal - discounted;
      const period = monthly ? config.text.monthPeriod : config.text.weeksPeriod;
      const rawPlanId = String(config.plans[term + '_' + cycle] || '').trim();
      const planId = rawPlanId.replace(/^gid:\/\/shopify\/SellingPlan\//, '');
      const allocation = (config.allocations || []).find(a => a && String(a.plan_id || a.selling_plan?.id || '') === planId);
      const billedUnit = unit * (prepaid ? deliveries : 1);
      const correctPrice = /^\d+$/.test(planId) && allocation && Number(allocation.per_delivery_price) === unit && Number(allocation.checkout_charge_amount) === billedUnit && Number(allocation.price) === billedUnit;
      const ready = root.dataset.live === 'true' && root.dataset.currency === 'CHF' && config.available && correctPrice && [4,8].includes(quantity) && ['month','fortnight'].includes(cycle) && ['flex','prepaid'].includes(term);
      setText('[data-ps-total]', money(charge));
      setText('[data-ps-charge-label]', prepaid ? (monthly ? config.text.quarterLabel : config.text.weeksLabel) : (monthly ? config.text.monthLabel : config.text.fortnightLabel));
      setText('[data-ps-unit]', money(unit) + ' ' + config.text.perPack);
      setText('[data-ps-schedule]', prepaid ? (monthly ? config.text.quarterly : config.text.sixDeliveries) : '');
      root.querySelector('[data-ps-schedule]').hidden = !prepaid;
      setText('[data-ps-flex-note]', config.text.flexNote);
      const renewal = prepaid ? (monthly ? config.text.renewalQuarter : config.text.renewalWeeks) : (monthly ? config.text.renewalMonth : config.text.renewalFortnight);
      setText('[data-ps-renewal]', render(renewal, {amount: money(charge)}));
      setText('[data-ps-prepaid-note]', monthly ? config.text.threeNote : config.text.weeksNote);
      setText('[data-ps-saving-detail]', render(config.text.savingDetail, {amount: money(savings), period}));
      root.querySelector('[data-ps-saving-detail]').hidden = !prepaid;
      const weeksFaq = root.querySelector('[data-ps-weeks-faq]');
      weeksFaq.hidden = monthly || !prepaid;
      if (weeksFaq.hidden) weeksFaq.open = false;
      setText('[data-ps-journey-selection]', render(config.text.journeySelection, {packs: quantity, plan: prepaid ? config.text.journeyPrepaid : config.text.journeyFlex}));
      setText('[data-ps-journey-delivery]', render(config.text.journeyDelivery, {packs: quantity}));
      setText('[data-ps-journey-next]', monthly ? config.text.journeyMonth : config.text.journeyFortnight);
      planInput.value = ready ? planId : '';
      submit.disabled = !ready || !consent.checked;
      acceptedTerms.value = consent.checked ? [money(charge), root.querySelector('[data-ps-charge-label]').textContent, quantity + ' × 100 g', monthly ? config.text.monthLabel : config.text.fortnightLabel, root.querySelector('[data-ps-renewal]').textContent].join(' · ') : '';
      root.querySelector('[data-ps-status]').hidden = ready;
      setText('[data-ps-status]', ready ? config.text.ready : config.text.preview);
    };
    const resetJourney = () => {
      journey.classList.remove('is-complete');
      motion.textContent = journey.classList.contains('is-paused') ? config.text.play : config.text.pause;
      journey.classList.add('is-reset');
      void journey.offsetWidth;
      journey.classList.remove('is-reset');
    };
    form.addEventListener('change', event => {
      if (event.target.matches('input[type="radio"]')) { consent.checked = false; resetJourney(); }
      update();
    });
    journey.addEventListener('animationend', event => {
      if (!event.animationName.startsWith('ps-abo-route')) return;
      journey.classList.add('is-complete');
      motion.textContent = config.text.replay;
      motion.setAttribute('aria-pressed', 'false');
    });
    motion.addEventListener('click', () => {
      if (journey.classList.contains('is-complete')) { resetJourney(); return; }
      const paused = journey.classList.toggle('is-paused');
      motion.setAttribute('aria-pressed', String(paused));
      motion.textContent = paused ? config.text.play : config.text.pause;
    });
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => journey.classList.toggle('is-visible', entry.isIntersecting));
    }, {threshold: 0.15});
    observer.observe(journey);
    document.addEventListener('shopify:section:unload', event => {
      if (event.target.contains(root)) observer.disconnect();
    });
    form.addEventListener('submit', event => {
      update();
      if (submit.disabled || !planInput.value || !consent.checked || !form.checkValidity()) event.preventDefault();
    });
    update();
  });
}
initPimpSeedsCompactAbos();
document.addEventListener('shopify:section:load', initPimpSeedsCompactAbos);


